import { render, staticRenderFns } from "./SalesCard.vue?vue&type=template&id=386adcac&scoped=true"
import script from "./SalesCard.vue?vue&type=script&lang=js"
export * from "./SalesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386adcac",
  null
  
)

export default component.exports